import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';

import { AiAnalysisTypes } from '../../../../Common/Mentions/enums/ai-analysis-types.enum';
import { DropdownOptionModel } from '../../../../Common/Forms/models/dropdown-option.model';
import { CoverageInsights } from '../../../Shared/models/coverage-insights.model';
import { CustomInsights } from '../../../Shared/models/custom-insights.model';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { Subscription } from 'rxjs';


@Component({
    selector: 'agpr-coverage-insights-form',
    templateUrl: './coverage-insights-form.component.html',
    styleUrls: ['./coverage-insights-form.component.scss'],
    standalone: false
})
export class CoverageInsightsFieldsComponent implements OnChanges, OnInit, OnDestroy {
    readonly coverageInsightTypes = AiAnalysisTypes;
    @Input() value: CoverageInsights;
    @Input() customInsight: CustomInsights;

    includeKeyTakeaways: boolean = false;
    keyTakeawayHeading: string = null;
    analysisInstructions: string = '';

    promptLanguageOptions: DropdownOptionModel[] = [];
    selectedLanguageOption: DropdownOptionModel;

    selectedLengthOption: DropdownOptionModel;
    lengthOptions: DropdownOptionModel[] = [];

    readonly keyTakeawayOptions = [
        new DropdownOptionModel('1', 1),
        new DropdownOptionModel('2', 2),
        new DropdownOptionModel('3', 3),
        new DropdownOptionModel('4', 4),
        new DropdownOptionModel('5', 5),
        new DropdownOptionModel('6', 6),
        new DropdownOptionModel('7', 7),
        new DropdownOptionModel('8', 8),
        new DropdownOptionModel('9', 9),
        new DropdownOptionModel('10', 10),
    ];

    @Output() formChanged = new EventEmitter<CoverageInsights>();
    @Output() customFormChanged = new EventEmitter<CustomInsights>();

    subscriptions: Subscription[] = [];

    constructor(
        public currentUserStateService: CurrentUserStateService
    ) {}

    ngOnInit() {
        this.promptLanguageOptions = this.value.languageOptions;
        this.lengthOptions = this.value.lengthOptions;

        this.subscriptions.push(
            this.currentUserStateService.getUILanguageTag().subscribe(tag => {
                this.promptLanguageOptions.forEach(option => {
                    option.label = tag + '.' + option.value;
                });
            })
        );
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.value?.currentValue) {
            this.lengthOptions = changes?.value?.currentValue.lengthOptions;
        }
        if (changes?.value?.currentValue?.selectedLanguageOption) {
            this.selectedLanguageOption = changes?.value?.currentValue?.selectedLanguageOption;
        }

        if (changes?.value?.currentValue?.selectedLengthOption) {
            this.selectedLengthOption = changes?.value?.currentValue?.selectedLengthOption;
        }

        if (changes?.value?.currentValue?.keyTakeawayHeading) {
            this.includeKeyTakeaways = true;
            this.keyTakeawayHeading = changes?.value?.currentValue?.keyTakeawayHeading;
        } else {
            this.includeKeyTakeaways = false;
            this.keyTakeawayHeading = null;
        }
    }

    handleCustom() {
        this.customFormChanged.emit(this.customInsight);
    }

    emitValue() {
        this.value.selectedLanguageOption = this.selectedLanguageOption;
        this.value.selectedLengthOption = this.selectedLengthOption;
        if (this.includeKeyTakeaways) {
            if (!this.keyTakeawayHeading) {
                this.keyTakeawayHeading = 'Key Takeaways';
            }
        } else {
            this.keyTakeawayHeading = null;
        }
        this.value.keyTakeawayHeading = this.keyTakeawayHeading;
        this.formChanged.emit(this.value);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
